<template>
	<div class="order-list-item van-hairline--bottom">
		<div class="f-color2 d-flex">
			<van-icon name="orders-o" style='transform:translateY(1px);margin-right:2px;' />
			<span class="flex-1">{{item.orderNO}}</span>
			<span class="fz15">
				<span class="f-color3" v-if='item.status===-1'>已取消</span>
				<span class="f-color2" v-else-if='item.status===0'>待确认</span>
				<span class="f-main" v-else-if='item.status===1'>进行中</span>
				<span class="f-success" v-else-if='item.status===2'>已完成</span>
			</span>
		</div>
		<van-steps :active="item.orderStatus" v-if='steps&&steps.length>0'>
			<van-step active-color="#dcaf5d" v-for='(item) in steps' :key='item.id'>{{item.name}}</van-step>
		</van-steps>
		<div class="mb-5 pl-10 pr-10">
			<div class="d-flex detail">
				<div class="flex-1 ">
					<span>订单金额：</span>
					<span>
						<span class="fz14">￥</span>
						<span class="f-danger">{{item.amount}}</span>
					</span>
				</div>
				<div class="flex-1 ">
					<span>支付状态：</span>
					<span class="f-color3 fz13" v-if='item.payStatus===-1'>支付失败</span>
					<span class="f-color2 fz13" v-else-if='item.payStatus===0'>待支付</span>
					<span class="f-success fz13" v-else-if='item.payStatus===1'>已支付</span>
				</div>
			</div>
			<div class="d-flex detail">
				<div class="flex-1 ">
					<span>应用平台：</span>
					<span>
						{{item.appName}}
					</span>
				</div>
				<div class="flex-1 ">
					<span>订单类型：</span>
					<span class="fz13 f-color3">{{item.categoryName}}</span>
				</div>
			</div>
		</div>
		<div class="d-flex mt-10" middle>
			<van-icon name="location" color='#DDDDDD' />
			<span class="f-color3">{{item.orderAddress}}</span>
			<span class="flex-1"></span>
			<span class="fz13 f-color4">{{item.orderTime|timeauto}}</span>
		</div>
		<wx-open-launch-weapp :appid="appobj[item.appId].appId" :path="`${item.url||appobj[item.appId].host}?mazid=${$config.userinfo.mazId}`" v-if='appobj[item.appId]'>
			<script type="text/wxtag-template"><button style='display:inline-block;position:absolute;width:100%;height:100%;'>跳转</button></script>
		</wx-open-launch-weapp>
	</div>
</template>
<script>
	export default {
		props: ["item", "configobj", "appobj"],
		data() {
			return {};
		},
		computed: {
			steps() {
				var list = [];

				if (this.configobj[this.item.configId]) {
					var items = this.configobj[this.item.configId];
					if (items.length <= 5) {
						return items;
					}
					var c = parseInt(this.item.orderStatus);
					var cindex = items.findIndex((x) => x.value == c);

					if (cindex >= 0) {
						var item = items[cindex];
						var start = cindex - 2;
						var end = cindex + 2;
						if (start < 0) {
							end += 0 - start;
							start = 0;
						} else if (end > item.length - 1) {
							start += end - item.length - 1;
							end = item.length - 1;
						}

						for (var i = start; i <= end; i++) {
							list.push(items[i]);
						}
					}
				}
				return list;
			},
		},
	};
</script>
<style lang="less">
.order-list-item {
	padding: 10px;
	background-color: white;
	margin-bottom: 8px;
	position: relative;

	wx-open-launch-weapp {
		display: inline-block;
		opacity: 0;
		width: 100%;
		height: 100%;
		position: absolute;
		top: 0px;
		left: 0px;
		z-index: 1;
	}

	.applogo {
		width: 20px;
		height: 20px;
	}

	.detail {
		.flex-1 {
			span {
				&:first-child {
					font-size: 13px;
					color: @fontcolor3;
				}
			}
		}

		.detail-item {
			font-size: 15px;
			color: @fontcolor3;
			word-break: break-all;
			span {
				margin-right: 5px;
			}
		}
	}
}
</style>